import ApiService from '@/services/api.service'

const PostPaymentService = {
    getEraRemitList() {
        return ApiService.get(`PostPayment/eraRemitList`)
    },
   

    getPaymentFilteredList(parameter) {          
      const params= {
            DateFrom:parameter.FromDate,
            DateTo:parameter.ToDate,
            Downloaded:parameter.Downloaded,            
            Posted:parameter.Posted,
            InsuranceCodeList:parameter.InsuranceCodeList,
            SortIndex:parameter.SortIndex,
            hasErrors:parameter.hasErrors,
            SearchCriteria: parameter.SearchCriteria,
            PageSize: parameter.PageSize,
            PageNumber: parameter.PageNumber  
        }
        return ApiService.getWithArray('/PostPayment/eraRemitFiltered/',params);
    },

    getInsurance(){
        return ApiService.get(`PostPayment/getInsuranceFilter`);
    },

    changeDownloadFlag(data){
        return ApiService.put(`PostPayment/download`, data)
    },
    postPayment(data){
        return ApiService.post(`PostPayment/postPayment`, data)
    },
    getTransNo(params){
        return ApiService.get(`PostPayment/transNo/${params}`)
    },
    getPaymentDetails(params){
        return ApiService.get(`PostPayment/details/${params}`)
    },

   /* getException(params){
        return ApiService.get(`PostPayment/exception?id=${params}`)
    },*/

    getException(parameter) {          
      const params= {
            id:parameter.PaymentId,
         //   PageSize: parameter.PageSize,
          //  PageNumber: parameter.PageNumber  
        }
        return ApiService.getWithArray('PostPayment/exception',params);
    },

    getEraClaims(params){
        return ApiService.get(`PostPayment/claimERA?PatientCode=${params.PatientCode}&DateFrom=${params.DateFrom}`)
    },
    validateIssLineNo(params){
        return ApiService.get(`PostPayment/validateIss?IssLineNo=${params.IssLineNo}&PatientCode=${params.PatientCode}&Id=${params.Id}`)
    }
}

export default PostPaymentService;